
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.376 10.145a6.236 6.236 0 00-3.072-2.69 3.842 3.842 0 10-4.61 0 6.236 6.236 0 00-3.073 2.69.606.606 0 101.05.607c.916-1.583 2.533-2.528 4.327-2.528 1.795 0 3.412.945 4.328 2.528a.607.607 0 001.05-.607zM3.37 4.382a2.629 2.629 0 115.257 0 2.629 2.629 0 01-5.257 0z"}})])
          )
        }
      }
    